import { useMemo } from 'react'
import styled from 'styled-components'

import { generateTagId } from '@/utils/test-automation'

export interface Props {
  country: string
  text: {
    start: string
  }
  onClose: () => void
}
const SignUpPopup = ({ country, text, onClose }: Props): JSX.Element => {
  const imgSrc = useMemo(() => `/images/banners/signup_popup_${country}.svg`, [country])

  return (
    <StyledContainer>
      <StyledImage src={imgSrc} alt="download banner" />
      <StyledButton
        id={generateTagId('signup', 'popup', 'btn', 'close')}
        onClick={() => {
          onClose()
        }}
      >
        {text.start}
      </StyledButton>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  width: 100%;
  max-width: 288px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 16px;
`

const StyledImage = styled.img`
  width: 100%;
`

const StyledButton = styled.button`
  background-color: #fff;
  color: #000;
  font-weight: bold;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  border: none;
  padding: 12px 0;
  cursor: pointer;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
`

export default SignUpPopup
